export default "dist/images/block-header-half-overlay.9673c18.png";